import moment from 'moment';
import { t } from '../common/LocalizationProvider';

export const formatPosition = (value, key) => {
  if (value != null && typeof value === 'object' && value !== 'NaN') {
    value = value[key];
  }
  switch (key) {
    case 'fixTime':
    case 'deviceTime':
    case 'serverTime':
    case 'eventTime':
    case 'userExpirationTime':
      return formatDate(value);
    case 'latitude':
    case 'longitude':
      return value?.toFixed(5);
    case 'speed':
    case 'fuelelevel':
    case 'course':
      return value?.toFixed(1);
    case 'batteryvoltage':
    case 'fuelrate':
      return value + '%';
    default:
      if (typeof value === 'number') {
        return formatNumber(value);
      } else if (typeof value === 'boolean') {
        return formatBoolean(value);
      }else if (typeof value === 'string') {
        return  value?.charAt(0).toUpperCase() + value?.slice(1);
      } else {
        return value;
      }
  }
};

export const formatBoolean = (value) => {
  return value.subadmin ? t('sharedYes') : t('sharedNo');
};

export const formatBooleanDesable = (value) => {
  return value.disabled ? t('sharedYes') : t('sharedNo');
};

export const formatNumber = (value, precision = 1) => {
  if (value && value !=='NaN')
    return Number(value.toFixed(precision));
};

export const formatDate = (value, format = 'YYYY-MM-DD HH:mm') => {
  return moment(value).format(format);
};

export const formatDistance = (value, unit) => {
  switch (unit) {
    case 'mi':
      return `${(value * 0.000621371).toFixed(2)} ${t('sharedMi')}`;
    case 'nmi':
      return `${(value * 0.000539957).toFixed(2)} ${t('sharedNmi')}`;
    case 'meters':
      return `${(value).toFixed(2)} ${t('sharedMeters')}`;
    case 'km':
    default:
      return `${(value * 0.001).toFixed(2)} ${t('sharedKm')}`;
  }
};

export const formatWeight = (value, unit) => {
  switch (unit) {
    case 'kg':
      return `${(value)} ${t('sharedKg')}`;
    case 'grams':
      return `${(value).toFixed(9)} ${t('sharedGram')}`;
    case 'metric_tons':
      return `${(value).toFixed(9)} ${t('sharedMetricTone')}`;
    default:
      return `${(value)} ${t('sharedGram')}`;
  }
};

export const formatSpeed = (value, unit) => {
  switch (unit) {
    case 'kmh':
      return  `${(value * 1).toFixed(2)} ${t('sharedKmh')}`;
    case 'kmhFix0':
      return  `${(value * 1).toFixed(0)} ${t('sharedKmh')}`;
    case 'mph':
      return `${((value / 1.852) * 1.15078 ).toFixed(2)} ${t('sharedMph')}`;
    case 'kn':
      return `${(value / 1.852).toFixed(2)} ${t('sharedKn')}`;
    default:
      return `${(value * 1).toFixed(2)} ${t('sharedKmh')}`;
  }
};

export const formatSpeedSeparated = (value, unit) => {
  switch (unit) {
    case 'kmh':
      return { value: (value * 1).toFixed(2), unit: t('sharedKmh') };
      // return  `${(value * 1).toFixed(2)} ${t('sharedKmh')}`;
    case 'kmhFix0':
      return { value: (value * 1).toFixed(2), unit: t('sharedKmh') };

      // return  `${(value * 1).toFixed(0)} ${t('sharedKmh')}`;
    case 'mph':
      return { value: ((value / 1.852) * 1.15078 ).toFixed(2), unit: t('sharedMph') };

      // return `${((value / 1.852) * 1.15078 ).toFixed(2)} ${t('sharedMph')}`;
    case 'kn':
      return { value: (value / 1.852).toFixed(2), unit: t('sharedKn') };

      // return `${(value / 1.852).toFixed(2)} ${t('sharedKn')}`;
    default:
      return { value: (value * 1).toFixed(2), unit: t('sharedKmh') };

      // return `${(value * 1).toFixed(2)} ${t('sharedKmh')}`;
  }
};

// export const formatSpeed = (value, unit) => {
//   switch (unit) {
//     case 'kmh':
//       return  `${(value * 1.852).toFixed(2)} ${t('sharedKmh')}`;
//     case 'mph':
//       return `${(value * 1.15078).toFixed(2)} ${t('sharedMph')}`;
//     case 'kn':
//     default:
//       return `${(value * 1).toFixed(2)} ${t('sharedKmh')}`;
//   }
// };


export const formatVolume = (value, unit) => {
  switch (unit) {
    case 'impGal':
      return `${(value / 4.546).toFixed(2)} ${t('sharedGallonAbbreviation')}`;
    case 'usGal':
      return `${(value / 3.785).toFixed(2)} ${t('sharedGallonAbbreviation')}`;
    case 'ltr':
    default:
      return `${(value / 1).toFixed(2)} ${t('sharedLiterAbbreviation')}`;
  }
}

export const formatAgt = (value, unit) => {
  switch (unit) {
    case 'KgCo2/tn-Km':
      return `${(value ).toFixed(5)} ${t('sharedKgCo2/tn-Km')}`;
    case 'kgCO2':
      return `${(value ).toFixed(5)} ${t('sharedKgCo2')}`;
    case 'Co2/tn-Km':
      return `${(value*1000 ).toFixed(9)} ${t('sharedGramCo2/tn-Km')}`;
    default:
      return `${(value / 1).toFixed(2)} ${t('sharedLiterAbbreviation')}`;
  }
}

export const formatHours = (value) => {
  return moment.duration(value).humanize();
};

export const formatHoursSeparated = (value) => {
  const humanized = moment.duration(value).humanize();
  const match = humanized.match(/(\d+(\.\d+)?)\s*(.*)/);
  if (match) {
    const numericValue = match[1];
    const unit = match[3];
    return { value: numericValue, unit: unit };
  } else {
    return { value: '', unit: humanized };
  }
};

export const formatNumberHours = (value) => {
  const duration = moment.duration(value);
  const hours = duration.asHours();
  const minutes = duration.asMinutes();
  const seconds = duration.asSeconds();

  if (hours >= 1) {
    return `${hours.toFixed(0)}`;
  } else if (minutes >= 1) {
    return `${minutes.toFixed(0)}`;
  } else {
    return `${seconds.toFixed(0)}`;
  }
};

export const formatUnitTime = (value) => {
  const duration = moment.duration(value);
  const hours = duration.asHours();
  const minutes = duration.asMinutes();

  if (hours >= 1) {
    return `Hours`;
  } else if (minutes >= 1) {
    return `Minutes`;
  } else {
    return `Seconds`;
  }
};

export const formatCoordinate = (key, value, unit) => {
  var hemisphere, degrees, minutes, seconds;
  if (key === 'latitude') {
    hemisphere = value >= 0 ? 'N' : 'S';
  } else {
    hemisphere = value >= 0 ? 'E' : 'W';
  }

  switch (unit) {
    case 'ddm':
      value = Math.abs(value);
      degrees = Math.floor(value);
      minutes = (value - degrees) * 60;
      return degrees + '° ' + minutes.toFixed(6) + '\' ' + hemisphere;
    case 'dms':
      value = Math.abs(value);
      degrees = Math.floor(value);
      minutes = Math.floor((value - degrees) * 60);
      seconds = Math.round((value - degrees - minutes / 60) * 3600);
      return degrees + '° ' + minutes + '\' ' + seconds + '" ' + hemisphere;
    default:
      return value.toFixed(6) + '°';
  }
};

export const formatterTimeDuration = (position, device) => {
  const now = new Date();
  if (position) {
    if (device.status === 'slowing' || device.status === 'online')
      return`${position.speed.toFixed(0)}Km/h`
    const deviceDate = new Date(position.deviceTime);
    const diffInSeconds = Math.floor((now - deviceDate) / 1000);
    if (diffInSeconds < 60) {
      return `${1} ${t('minute')}`;
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} ${minutes !== 1 ? t('minutes') : t('minute')}`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} ${hours !== 1 ? t('hours') : t('hour')}`;
    } else if (diffInSeconds < 2592000) {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days} ${days !== 1 ? t('days') : t('day')}`;
    } else if (diffInSeconds < 31536000) {
      const months = Math.floor(diffInSeconds / 2592000);
      return `${months} ${months !== 1 ? t('months') : t('month')}`;
    } else {
      const years = Math.floor(diffInSeconds / 31536000);
      return `${years} ${years !== 1 ? t('years') : t('year')}`;
    }
  }
  else
    return '';
}

